module.exports = __webpack_public_path__ + "img/singletrack-study-research.91de89f9.png";